import { render } from "./Sets.vue?vue&type=template&id=b338a6c4"
import script from "./Sets.vue?vue&type=script&lang=js"
export * from "./Sets.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__